import styled from "@emotion/styled";
import React from "react";
import { Typography } from "../Typography";

type Props = {
  billingName: string;
  billingEmail: string;
  firstLine: string;
};

const AddressText = styled(Typography)`
  color: ${({ theme }) => theme.colors.forest};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

export const BillingAddressDisplay = ({
  billingName,
  billingEmail,
  firstLine,
}: Props) => (
  <div>
    <AddressText use="body1">{billingEmail}</AddressText>
    <AddressText use="body1">{`${billingName}, ${firstLine.substring(
      0,
      25
    )}...`}</AddressText>
  </div>
);
